'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');

var _require = require('spectacle'),
    Image = _require.Image;

var style = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};

var CodeSlideImage = function (_React$Component) {
  _inherits(CodeSlideImage, _React$Component);

  function CodeSlideImage() {
    _classCallCheck(this, CodeSlideImage);

    return _possibleConstructorReturn(this, (CodeSlideImage.__proto__ || Object.getPrototypeOf(CodeSlideImage)).apply(this, arguments));
  }

  _createClass(CodeSlideImage, [{
    key: 'render',
    value: function render() {
      return React.createElement(Image, { src: this.props.src, style: style });
    }
  }]);

  return CodeSlideImage;
}(React.Component);

module.exports = CodeSlideImage;


//////////////////
// WEBPACK FOOTER
// ./~/spectacle-code-slide/lib/CodeSlideImage.js
// module id = 886
// module chunks = 0